import { uniqueId } from 'js/utils/methods.util';
import { send } from 'server';
import uuid from 'uuid-random';
import { BALANCE_TYPES } from './constants';

export const getComppointsDetails = (balanceTypes) => send({
    ID: 31020,
    responses: [31021, 31025],
    description: 'Get loyalty points details',
    correlationId: uniqueId('loyalty-points-'),
    balanceTypes: [BALANCE_TYPES.total, BALANCE_TYPES.convert, ...balanceTypes.map(el => BALANCE_TYPES[el])]
});

export const getComppointsConversion = () => send({
    ID: 35616,
    responses: [35617, 35618],
    description: 'Get loyalty points conversion',
    correlationId: uniqueId('loyalty-points-')
});

export const getComppointsBonusTemplate = (bonusCodes, isGameContext) => send({
    ID: 31079,
    responses: [31080, 31081],
    description: `Get ${isGameContext ? 'bonus' : 'after-wager'} template details`,
    correlationId: uniqueId('loyalty-points-'),
    bonusTemplateCodes: bonusCodes,
    returnGamingContexts: isGameContext,
    returnWageringCoefficients: false
});

export const convertComppoints = ({
    pointsAmount,
    convertType = 'money',
    conversionRuleId
}) => send({
    ID: 35781,
    responses: [35782, 35783],
    description: 'Convert loyalty points',
    correlationId: uniqueId('loyalty-points-'),
    transactionCode: uuid().slice(0, 20),
    transactionDate: new Date().toISOString()
        .replace(/[TZ]/ig, ' ')
        .trim(),
    pointsAmount,
    convertType,
    conversionRuleId
});

export const setConvertedComppointsAction = () => ({
    // todo
});
